<br>
<div class="inicio">

    <mat-tab-group>

        <mat-tab label="PENDIENTES">
            <p class="titulo"><br>
                MANTENIMIENTOS AGENDADOS
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)">
                    <mat-icon>info</mat-icon>
                </button><br>
            </p>

            <br><br>


            <div class="grid-container">

                <mat-form-field>
                    <input matInput (keyup)="filtroDataDourceSR($event)"  placeholder="Ingrese el nombre de la sucursal, fecha de mantenimeinto o dato que desee buscar" oninput="this.value = this.value.toUpperCase()" >
                </mat-form-field>

                <table mat-table [dataSource]="dataSourceSR" class="mat-elevation-z8">

                    <ng-container matColumnDef="OPCIONES">
                      <th mat-header-cell *matHeaderCellDef>  </th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="accent" matTooltip="Click para editar y ver a detalle" (click)="clickEditar(element.id_registro_mantenimiento)">
                            <mat-icon>edit</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="SUCURSAL">
                        <th mat-header-cell *matHeaderCellDef> SUCURSAL </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_sucursal}} </td>
                    </ng-container>

                    <ng-container matColumnDef="AGENDADO POR">
                        <th mat-header-cell *matHeaderCellDef> AGENDADO POR </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_empleado_registra}} </td>
                    </ng-container>

                    <ng-container matColumnDef="OBSERVACIONES GENERALES">
                        <th mat-header-cell *matHeaderCellDef> OBSERVACIONES GENERALES </th>
                        <td mat-cell *matCellDef="let element"> {{element.observ_generales}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA AGENDADA">
                        <th mat-header-cell *matHeaderCellDef> FECHA AGENDADA </th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_agendad_tabla}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA DE CREACIÓN">
                        <th mat-header-cell *matHeaderCellDef> FECHA DE CREACIÓN </th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_modific_tabla}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="listaEncabezadoSR"></tr>
                    <tr mat-row *matRowDef="let row; columns: listaEncabezadoSR;"></tr>
                </table>

            </div>
        </mat-tab>

        <mat-tab label="REALIZADOS"  >
            <p class="titulo"><br>
                MANTENIMIENTOS REALIZADOS
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)">
                    <mat-icon>info</mat-icon>
                </button><br>
            </p>

            <br><br>

            <div class="grid-container">

                <mat-form-field>
                    <input matInput (keyup)="filtroDataDourceR($event)"  placeholder="Ingrese la sucursal, fecha de mantenimiento o dato que desee buscar" oninput="this.value = this.value.toUpperCase()" >
                </mat-form-field>

                <table mat-table [dataSource]="dataSourceR" class="mat-elevation-z8">

                    <ng-container matColumnDef="OPCIONES">
                      <th mat-header-cell *matHeaderCellDef>  </th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="accent" matTooltip="Click para ver a detalle" (click)="clickVisualizar(element.id_registro_mantenimiento,element.status_registro)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="SUCURSAL">
                        <th mat-header-cell *matHeaderCellDef> SUCURSAL </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_sucursal}} </td>
                    </ng-container>

                    <ng-container matColumnDef="TIPO DE REGISTRO">
                        <th mat-header-cell *matHeaderCellDef>  TIPO DE REGISTRO </th>
                        <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="AGENDADO POR">
                        <th mat-header-cell *matHeaderCellDef> AGENDADO POR </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_empleado_registra}} </td>
                    </ng-container>

                    <ng-container matColumnDef="REALIZADO POR">
                        <th mat-header-cell *matHeaderCellDef> REALIZADO POR </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_empleado_realiza}} </td>
                    </ng-container>

                    <ng-container matColumnDef="OBSERVACIONES GENERALES">
                        <th mat-header-cell *matHeaderCellDef> OBSERVACIONES GENERALES </th>
                        <td mat-cell *matCellDef="let element"> {{element.observ_generales}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA DE REALIZACIÓN">
                        <th mat-header-cell *matHeaderCellDef> FECHA DE REALIZACIÓN </th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_modific_tabla}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="listaEncabezadoR"></tr>
                    <tr mat-row *matRowDef="let row; columns: listaEncabezadoR;"></tr>
                </table>

            </div>
        </mat-tab>

        <mat-tab label="CANCELADOS"  >
            <p class="titulo"><br>
                MANTENIMIENTOS CANCELADOS
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)">
                    <mat-icon>info</mat-icon>
                </button><br>
            </p>

            <br><br>
            <div class="grid-container">

                <mat-form-field>
                    <input matInput (keyup)="filtroDataDourceC($event)"  placeholder="Ingrese la sucursal o dato que desee buscar" oninput="this.value = this.value.toUpperCase()" >
                </mat-form-field>

                <table mat-table [dataSource]="dataSourceC" class="mat-elevation-z8">

                    <ng-container matColumnDef="OPCIONES">
                      <th mat-header-cell *matHeaderCellDef>  </th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="accent" matTooltip="Click para editar y ver a detalle" (click)="clickVisualizar(element.id_registro_mantenimiento,element.status_registro)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="SUCURSAL">
                        <th mat-header-cell *matHeaderCellDef> SUCURSAL </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_sucursal}} </td>
                    </ng-container>

                    <ng-container matColumnDef="OBSERVACIONES GENERALES">
                        <th mat-header-cell *matHeaderCellDef> OBSERVACIONES GENERALES </th>
                        <td mat-cell *matCellDef="let element"> {{element.observ_generales}} </td>
                    </ng-container>

                    <ng-container matColumnDef="AGENDADO POR">
                        <th mat-header-cell *matHeaderCellDef> AGENDADO POR </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_empleado_registra}} </td>
                    </ng-container>

                    <ng-container matColumnDef="CANCELADO POR">
                        <th mat-header-cell *matHeaderCellDef> CANCELADO POR </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_empleado_realiza}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA AGENDADA">
                        <th mat-header-cell *matHeaderCellDef> FECHA AGENDADA </th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_agendad_tabla}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA DE CANCELACION">
                        <th mat-header-cell *matHeaderCellDef> FECHA DE CANCELACION </th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_modific_tabla}} </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="listaEncabezadosC"></tr>
                    <tr mat-row *matRowDef="let row; columns: listaEncabezadosC;"></tr>
                </table>

            </div>
        </mat-tab>

        <mat-tab label="GENERAR REPORTES">
            <p class="titulo"><br>
                REPORTES DE MANTENIMIENTO
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacionReportes($event)">
                    <mat-icon>info</mat-icon>
                </button><br>
            </p>

            <br><br>


            <mat-label class="label"> REPORTE GENERAL </mat-label>
            <div class="grid-container3">

                <mat-form-field appearance="fill">
                    <mat-label>Rango de fechas</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                      <input matStartDate formControlName="start" placeholder="Start date">
                      <input matEndDate   formControlName="end" placeholder="End date">
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>

                    <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                    <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                </mat-form-field>

                <div class="example-button-row">

                    <button mat-raised-button color="primary" matTooltip="Descargar reporte general" [disabled]="!habilitarBotonReporteGenerl()" (click)="clickCrearReporteGeneral($event)" >Descargar</button>

                </div>

            </div>

            <br><br><br>

            <mat-label class="label"> REPORTE A DETALLE </mat-label>
            <div class="grid-container3">

                <mat-form-field appearance="fill" floatLabel="always">
                    <mat-label> Tipo de mantenimiento </mat-label>
                    <mat-select [(ngModel)]="tipo_mant_nombreD" (selectionChange)="seleccionTipoDeMantenimiento($event)">
                        <mat-option *ngFor="let activo of opciones__tipo__de__mantenimientoD" [value]=activo>{{ activo }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" floatLabel="always" *ngIf="bandera_status_mantenimiD">
                    <mat-label> Estatus </mat-label>
                    <mat-select [(ngModel)]="status_mantenimiD" >
                        <mat-option *ngFor="let activo of opciones_estatus_mantenimieD" [value]=activo>{{ activo }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Rango de fechas</mat-label>
                    <mat-date-range-input [formGroup]="rangeD" [rangePicker]="picker2">
                      <input matStartDate formControlName="startD" placeholder="Start date">
                      <input matEndDate   formControlName="endD" placeholder="End date">
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker2></mat-date-range-picker>

                    <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                    <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                </mat-form-field>

                <div class="example-button-row">

                    <button mat-raised-button color="primary" matTooltip="Descargar reporte a detalle" [disabled]="!habilitarBotonReporteDetalle()" (click)="clickCrearReporteDetalle($event)" >Descargar</button>

                </div>

            </div>

        </mat-tab>

    </mat-tab-group>

</div>
